<template>
  <div
    class="vaccine center"
    :class="{
      vacActive:
        $store.state.money >= 1000000 && $store.state.vaccineStatus == 'Locked',
    }"
  >
    <!-- TOOLTIP FIRST TIME -->
    <transition name="fade">
      <Tooltip
        :tWidth="320"
        :tBottom="72"
        :avatar="true"
        :hand="false"
        :centred="true"
        v-click-outside="tooltipStepOut"
        v-if="$store.state.tutStep == 5"
        >Now you know how to make money!<br />
        Earn 1,000,000 to invest in vaccine development</Tooltip
      >
    </transition>

    <!-- TOOLTIP NOT STARTED -->
    <Tooltip
      :tWidth="240"
      :tBottom="72"
      v-if="showTooltip"
      :avatar="false"
      :centred="true"
    >
      {{ fMoney }} of 1,000,000</Tooltip
    >

    <div
      class="vacIndication center"
      v-if="vaccineStatus === 'Locked'"
      v-click-outside="tooltipOut"
    >
      <svg
        width="48"
        height="48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="vaccineDev"
        v-click-outside="unlockedClick"
      >
        <mask
          id="mask0"
          maskUnits="userSpaceOnUse"
          x="10"
          y="9"
          width="28"
          height="37"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30 9.97461L29.9997 14.2966L31.2414 14.2977C34.9741 14.2977 38 17.6184 38 21.7146V46H10V21.7146C10 17.6184 13.0259 14.2977 16.7586 14.2977L17.9993 14.2966L18 9.97461H30Z"
            fill="#F2F3F8"
          />
        </mask>
        <g mask="url(#mask0)">
          <rect
            x="12.01"
            y="8"
            width="24.1203"
            height="36"
            fill="url(#paint0_linear)"
          />
          <rect
            id="vaccineLvl"
            x="10"
            y="10"
            width="28.1403"
            :height="heightLevel"
            fill="#F2F3F8"
          />
        </g>
        <path
          clip-rule="evenodd"
          d="M29.5714 9L29.5712 13.3189L30.7241 13.32C34.1902 13.32 37 16.6384 37 20.7318V45H11V20.7318C11 16.6384 13.8098 13.32 17.2759 13.32L18.4279 13.3189L18.4286 9H29.5714Z"
          stroke="#33333C"
          stroke-width="2"
        />
        <path
          d="M32 3H16C15.4477 3 15 3.38376 15 3.85714V8.14286C15 8.61624 15.4477 9 16 9H32C32.5523 9 33 8.61624 33 8.14286V3.85714C33 3.38376 32.5523 3 32 3Z"
          :fill="capFill"
          stroke="#33333C"
          stroke-width="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="24.0701"
            y1="8"
            x2="24.0701"
            y2="44"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFB23E" />
            <stop offset="1" stop-color="#E43EFF" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <!-- Vaccine in Progress -->
    <div class="vaccineProgress" v-if="vaccineStatus === 'Started'">
      <div class="numbers">
        <div class="percent">
          <span> {{ vaccineProgress }}%</span>
        </div>
        <div class="reward">
          <span class="will">You will get: </span>
          <span>{{ reward }}</span>
          <img src="@/assets/img/coin.svg" alt="Coin" />
        </div>
      </div>

      <div class="progress">
        <div class="bar" :style="{ width: vaccineProgress + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
export default {
  name: "Vaccine 2",
  components: { Tooltip },
  props: {},

  data() {
    return {
      showTooltip: false,
      raf: null, // request animation frame
      vaccineProgress: 0,
      vaccineDevStarted: 0,
    };
  },

  computed: {
    gamePause: function() {
      return this.$store.state.gamePause;
    },
    vaccineStatus: function() {
      return this.$store.state.vaccineStatus;
    },
    reward: function() {
      let reward = this.$store.state.money * 10;
      return reward.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    capFill: function() {
      if (this.$store.state.money <= 1000000) {
        return "#D6D8E0";
      } else {
        return "#FEAC48";
      }
    },
    heightLevel: function() {
      let percentage = this.$store.state.money / 1000000;
      if (percentage <= 1) {
        return 34 - 34 * percentage;
      } else {
        return 0;
      }
    },
    fMoney: function() {
      return this.$store.state.money
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    timeMulti: function() {
      return this.$store.state.timeMulti;
    },
  },

  mounted: function() {
    if (this.vaccineStatus === "Started") {
      this.startVaccine();
    }
    if (this.$store.state.tutStep === 4) {
      this.track("5th Step", "Onboarding");
      this.$store.commit("plusTutStep");
    }
  },

  watch: {
    gamePause: function(bool) {
      bool ? window.cancelAnimationFrame(this.raf) : this.startVaccine();
    },

    timeMulti: function() {
      window.cancelAnimationFrame(this.raf);
      this.startVaccine();
    },
  },

  methods: {
    vaccineDev: function() {
      if (this.$store.state.money <= 1000000) {
        this.showTooltip = true;
      } else {
        this.startVaccine();
        this.track("Vaccine Started", "Vaccine");
      }
    },
    unlockedClick: function() {
      // this.$store.commit("plusTutStep");
    },

    fillProgress: function() {
      this.raf = window.requestAnimationFrame(this.fillProgress);
      let timePassed = (performance.now() - this.vaccineDevStarted) / 1000;
      let percent =
        (timePassed /
          (this.$store.state.vaccineDevTime / this.$store.state.timeMulti)) *
        100;
      this.vaccineProgress = percent.toFixed(2);

      // Vaccine developed
      if (this.vaccineProgress >= 100) {
        this.track("Vaccine Developed", "Vaccine");
        window.cancelAnimationFrame(this.raf);
        this.$store.commit("setVaccineStatus", "Unlocked");
        this.$store.commit("addMoney", this.$store.state.money * 10);
      }
    },

    startVaccine: function() {
      this.vaccineDevStarted = performance.now();
      this.fillProgress();
      this.$store.commit("setVaccineStatus", "Started");
    },

    tooltipOut: function() {
      this.showTooltip = false;
    },

    tooltipStepOut: function() {
      this.$store.commit("plusTutStep");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.navBar {
  .vaccine {
    width: 100%;
    .vacIndication {
      padding: 6px 0;
      position: relative;
      border-radius: 12px;
      transition: all 1s ease;
      width: 60px;

      &:active,
      &:hover,
      &:focus {
        background: $gray100;
      }
    }

    // Progress
    .vaccineProgress {
      width: 100%;
      display: flex;
      flex-direction: column;
      .numbers {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px;
        .percent {
          font-weight: 600;
        }
        span {
          color: $black;
        }

        .reward {
          display: flex;

          .will {
            margin-right: 8px;
            color: $gray800;
          }

          img {
            margin-left: 8px;
          }
        }
      }

      .progress {
        width: 100%;
        background: $gray200;
        height: 32px;
        border-radius: 100px;
        padding: 0;
        overflow: hidden;
        .bar {
          border: solid $gray200 4px;
          height: 100%;
          background: linear-gradient(270deg, #ffb23e 0%, #e43eff 100%);
          border-radius: 100px;
        }
      }
    }
  }
}

// Active
.navBar {
  .vacActive {
    .vacIndication {
      background: #fff1b7 url("../assets/img/vaccine-bg.svg");
      border: 1px solid $orange;
      animation: vaccineActive 2s linear infinite;

      &:active,
      &:hover,
      &:focus {
        background: $orange;
      }
    }
  }
}

@keyframes vaccineActive {
  from {
    background-position-y: 0px;
  }
  to {
    background-position-y: -60px;
  }
}
</style>
